import { render, staticRenderFns } from "./SlotsModal.vue?vue&type=template&id=fcee0c10&scoped=true&"
import script from "./SlotsModal.vue?vue&type=script&lang=js&"
export * from "./SlotsModal.vue?vue&type=script&lang=js&"
import style0 from "./SlotsModal.vue?vue&type=style&index=0&id=fcee0c10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcee0c10",
  null
  
)

export default component.exports